import React, { FunctionComponent } from 'react';
import { useBreakpoint } from '@noths/polaris-client-responsive';
import { Breakpoint } from '@noths/polaris-client-styles';
import * as R from 'ramda';

import { RadioButtonGroup } from 'src/components/molecules/RadioButtonGroup';
import { Filter, SelectedFilterOption } from 'src/types';
import { FilterOptionsProps } from '../../types';
import { FilterOptionsExpandableContent } from './FilterOptionsExpandableContent';

const getSelectedRadioValue = (
  selectedFilterOptions: SelectedFilterOption[],
  filterUid?: string,
) => {
  // Note: using selectedFilterOptions to store value, not active flag
  const selectedFilterOption: SelectedFilterOption | undefined = R.find<SelectedFilterOption>(
    R.propEq('filterUid', filterUid),
  )(selectedFilterOptions);

  const selectedRadioValue: string | undefined = selectedFilterOption?.filterOptionValue as string;

  return selectedRadioValue;
};

type Props = Omit<FilterOptionsProps, 'currencyCode'>;

export const onChange = (
  radioButtonValue: string,
  filter: Filter,
  onSelectFilterOption: FilterOptionsProps['onSelectFilterOption'],
) =>
  onSelectFilterOption({
    filterUid: filter.uid,
    filterOptionValue: radioButtonValue,
  });

export const RadioButtonGroupWrapper: FunctionComponent<Props> = ({
  filter,
  selectedFilterOptions,
  onSelectFilterOption,
  onExpandableContentToggle,
}: Props) => {
  const breakpoint = useBreakpoint();
  const isExpandable = filter.options.length > 5 && breakpoint !== Breakpoint.SMALL;

  return (
    <FilterOptionsExpandableContent
      filter={filter}
      onExpandableContentToggle={onExpandableContentToggle}
      isExpandable={isExpandable}
    >
      <RadioButtonGroup
        name={filter.uid}
        accessibleLabel={filter.title}
        value={getSelectedRadioValue(selectedFilterOptions, filter.uid)}
        onChange={(radioButtonValue: string) =>
          onChange(radioButtonValue, filter, onSelectFilterOption)
        }
        radioButtonData={filter.options.map((filterOption) => ({
          labelText: filterOption.title,
          value: filterOption.value as string,
        }))}
        hideLabel
      />
    </FilterOptionsExpandableContent>
  );
};
